module.exports = __webpack_public_path__ + "static/media/logo-sm-light.1a587014.png";